import { BaseModel } from '../../common/base/model';

export class OldPortfolioModel extends BaseModel {
  constructor(data) {
    super(data, {
      data: {
        accounts: [],
        securities: [],
        funds: [],
      },
      disposeExemptionOrder: null,
      disposeExemptionOrderInfo: false,
      disposeSavingsPlan: null,
      disposeSavingsPlanInfo: false,
      disposeSecuritiesAccount: false,
      disposeSecuritiesAccountInfo: false,
      fragmentsProceedsDestinationAccountOwner: null,
      fragmentsProceedsDestinationBankName: null,
      fragmentsProceedsDestinationBic: null,
      fragmentsProceedsDestinationIban: null,
      sellFragments: null,
      sellFragmentsInfo: null,
      transferAllSecurities: false,
      transferCapitalLoss: null,
      transferCapitalLossInfo: false,
    });
  }

  precheckAllOptions(check = true) {
    this.disposeSavingsPlan = check;
    this.disposeSecuritiesAccount = check;
    this.sellFragments = check;
    this.transferAllSecurities = check;
    this.transferCapitalLoss = check;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/oldPortfolio/oldPortfolio.model.js